import React from 'react';
import _get from 'lodash/get';
import { makeStyles } from '@material-ui/core';
import VideoEmbedly from 'components/VideoEmbedly';

const useStyles = makeStyles(() => ({
  videoEmbedlyContainer: {
    height: props => props.isMobile && 171,
    '& iframe': {
      aspectRatio: props => !props.isMobile && '16/9',
      maxHeight: 220,
      height: props => props.isMobile && 171,
      padding: 0,
    },
  },
  videoEmbedly: props =>
    !props.isMobile && {
      '& > div': {
        borderRadius: 8,
        overflow: 'hidden',
      },
    },
}));

export const SeriesVideoPreview = ({
  item,
  trackingProps,
  isMobile,
  onProgressUpdate,
  initialTime,
  completed,
}) => {
  const classes = useStyles({ isMobile });

  return (
    <div className={classes.videoEmbedlyContainer}>
      <VideoEmbedly
        url={_get(item, 'fields.url')}
        imageUrl={_get(item, 'fields.imageUrl')}
        id={_get(item, 'sys.id')}
        title={_get(item, 'fields.title')}
        trackingProps={trackingProps}
        className={classes.videoEmbedly}
        onProgressUpdate={onProgressUpdate(item, completed)}
        initialTime={initialTime}
      />
    </div>
  );
};
